<div class="col-12">
  <div class="row">
    <div class="col-12">
      <p class="step_title">Step 5:</p>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="container_box">
        <div class="row">
          <div class="col-12">
            <div class="import-proccess-status import-title-header">
              {{_importStatus}}
            </div>
          </div>
        </div>
        @if (_running) {
          <div class="row"
            >
            <div class="col-12 import-proccess-loader">
              <asap-loader [withPopup]="false"></asap-loader>
            </div>
          </div>
        }
        @if (_running) {
          <div class="row"
            >
            <div class="col-12">
              <div class="import-proccess-messages-wrapper">
                <div class="import-proccess-messages"
                  *asapIfChanges="_messageToDisplay"
                  [@textChanges]>
                  {{_messageToDisplay}}
                </div>
              </div>
            </div>
          </div>
        }
        <div class="row no-margin margin_button_20">
          <div class="hr_separator"></div>
        </div>

        <div class="import-accounts-result">
          @if (!_currentUser.isEnterprise) {
            <div>
              @if (_importStatus != 'Importing files...') {
                <div class="row">
                  @if (ImportErrors.length == 0) {
                    <div class="col-10 import-title-header">
                      Data Imported successfuly to:
                    </div>
                  }
                  @if (ImportErrors.length > 0) {
                    <div class="col-10 import-title-header">
                      Data failed to be imported in:
                    </div>
                  }
                  @if (!_currentUser.isEnterprise) {
                    <div style="margin-left: 1px;" class="col-2 text-success text-nowrap font-weight-bold">
                      {{_dataCount}} {{_selectedModel.modelName}}
                    </div>
                  }
                </div>
              }
            </div>
          }


          @if (_currentUser.isEnterprise) {
            <div class="row">
              @if (_importStatus != 'Importing files...') {
                <div class="row">
                  <!--Success Enterprise Accounts-->
                  @if (_successAccountsCount > 0) {
                    <div class="row">
                      <div class="col-10 import-title-header">
                        Data Imported successfuly to:
                      </div>
                      <div class="col-2 text-success font-weight-bold">
                        {{_successAccountsCount}} Accounts
                      </div>
                    </div>
                  }
                  <!--Failed Enterprise Accounts-->
                  @if (_failureAccountsCount > 0) {
                    <div class="row">
                      <div class="col-10 import-title-header">
                        Data failed to be imported in:
                      </div>
                      <div class="col-2 text-danger font-weight-bold">
                        {{_failureAccountsCount}} Accounts
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
        @if (_resultGrids && _resultGrids.length > 0) {
          <div>
            @for (accountData of _resultGrids; track accountData) {
              <div  class="import-send-data-error-result"
                >
                <div class="import-title-header">{{accountData.account}}</div>
                <!-- <kendo-grid [data]="accountData.grid"
                [pageSize]="_pageSize"
                [skip]="_skip"
                [pageable]="true"
                (pageChange)="_pageChange($event, accountData.account)">
                <ng-container *ngFor="let field of _gridColumnsName">
                  <kendo-grid-column [field]="field.name"
                    [headerStyle]="{'font-weight': 'bold'}"
                    [style]="field.name != 'Error' ? {'color': '#212529'} : {'color': '#dc3545'}">
                  </kendo-grid-column>
                </ng-container>
              </kendo-grid> -->
              <kendo-grid [data]="accountData.grid"
                [pageSize]="_pageSize"
                [skip]="_skip"
                [pageable]="true"
                (pageChange)="_pageChange($event, accountData.account)">
                @for (field of _resultsGridDataColumns; track field) {
                  <kendo-grid-column [field]="field.field"
                    [title]="field.title"
                    [headerStyle]="{'font-weight': 'bold'}"
                    [style]="field.name != 'Error' ? {'color': '#212529'} : {'color': '#dc3545'}">
                  </kendo-grid-column>
                }
              </kendo-grid>
            </div>
          }
        </div>
      }

    </div>
  </div>
</div>
</div>
